import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import ClimaControl from './components/ClimaControl';

export default () => (
  <Layout>
    <Route exact path='/' component={Home} />
    <Route path='/climacontrol' component={ClimaControl} />
    <Route path='/counter' component={Counter} />
    <Route path='/fetchdata/:startDateIndex?' component={FetchData} />
  </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js